import { LubricantModel } from './../Modules/informate/models/lubricant-model';
import { Injectable } from '@angular/core';
import { CalculationResult } from '../Modules/informate/models/calculationModels';
import { BoltMaterialModel, FlangeMaterialModel, FlangeTypeModel, JointConfigurationModel, PressureClassModel } from '../Modules/informate/models';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DataService {
    isMatrixData: boolean;
    calculationData: CalculationResult;

    /* Create DataSheet Report Properties */
    // joint details
    selectedStandard: string;
    selectedPipeSize: string;
    selectedFlangeMaterial: string;
    selectedFlangeMaterialObject: FlangeMaterialModel;
    selectedGasketMaterial: string;
    selectedFlangeType: string;
    pressureClassList: PressureClassModel[];
    selectedPressureClass: string;

    // bolt details
    selectedBoltMaterial: string;
    selectedBoltMaterialObject: BoltMaterialModel;
    selectedLubricantObject: string;

    /* JCC Properties */

    // jointData details
    flangeTypeObj: FlangeTypeModel[];

    /* Torque Details */
    selectedToolId: string;
    selectedToolName: string;
    lubricantList: LubricantModel[];

    /* Data sheet report clamp */
    selectedClampManufacturer: string;
    selectedClampMaterial: string;
    selectedSealRingMaterial: string;
    selectedClampSize: string;
    selectedHubMaterial: string;

    /* Data sheet report engineered joint */
    selectedJointConfiguration: string;
    flangeMaterialList: FlangeMaterialModel[];
    jointConfigurationList: JointConfigurationModel[];

    selectedStandardCalcMode: number;
    isStandardCalcMode: Subject<boolean> = new Subject<boolean>();
    boltMaterialAliasId: string;
    flangeMaterialAliasId1: string;
    flangeMaterialAliasId2: string;
    gasketAliasId: string;
}
